export default __webpack_public_path__ + "static/betterData-4e2a4d73593bbe719d6d2c68be2b7d67.svg";